module.exports = __webpack_public_path__ + "img/solutions_s3d_3.86dc59a9.png";